<script>
    export default {

        props: ['id', 'progressCode', 'cssCodeMap', 'statusTitleMap'],

        data() {
            return {
                code: this.progressCode
            };
        },

        computed: {
            cssClass() {
                return JSON.parse(this.cssCodeMap)[this.code];
            },
            statusTitle() {
                return JSON.parse(this.statusTitleMap)[this.code];
            }
        },

        methods: {

            refreshProgress(items) {
                let el=this;
                items.children.forEach(function (child) {
                    if(child.id==el.id){
                        el.code=child.progressStatusCode;
                    }
                });
            }

        }
    }
</script>